import { EditableText } from "@risalabs_frontend_org/oasis-ui-kit";
import React from "react";
import "./editableTextWithIconCell.scss";

export interface EditableTextWithIconCellValue {
  value: string;
  placeholder?: string;
  emptyLabel?: string;
  disabled?: boolean;
  /** Max characters shown in read mode; full value is kept for editing. */
  displayMaxLength?: number;
}

interface EditableTextWithIconCellProps {
  value: EditableTextWithIconCellValue;
  rowData?: any;
  header?: string;
  onCellValueChange?: (rowData: any, fieldKey: string, newValue: any) => void;
}

const EditableTextWithIconCell: React.FC<EditableTextWithIconCellProps> = ({
  value,
  rowData,
  header,
  onCellValueChange,
}) => {
  /**
   * Key remount the oasis EditableText whenever the row changes, otherwise its
   * uncontrolled internal state sticks across pagination/sort/filter swaps and
   * we render the previous row's text.
   */
  const remountKey = `${rowData?.id ?? "row"}-${header ?? ""}`;
  const displayMaxLength = value.displayMaxLength;
  const fullValue = value.value || "";

  return (
    <div
      className={
        displayMaxLength
          ? "editable-text-with-icon-cell editable-text-with-icon-cell--truncated"
          : "editable-text-with-icon-cell"
      }
      style={
        displayMaxLength
          ? ({
              "--editable-text-max-ch": `${displayMaxLength}ch`,
            } as React.CSSProperties)
          : undefined
      }
      title={displayMaxLength && fullValue ? fullValue : undefined}
      onClick={(e) => e.stopPropagation()}
    >
      <EditableText
        key={remountKey}
        value={fullValue}
        defaultValue={fullValue}
        placeholder={value.placeholder}
        emptyText={value.emptyLabel || "—"}
        disabled={value.disabled}
        size="small"
        saveOnBlur
        saveOnEnter
        cancelOnEscape
        inputWidth={displayMaxLength ? "min(24rem, 100%)" : undefined}
        onSave={(next) =>
          onCellValueChange?.(rowData, header || "", next.trim())
        }
      />
    </div>
  );
};

export default EditableTextWithIconCell;
